// import Swiper, { Navigation, Pagination, A11y } from 'swiper';
// import 'swiper/modules';
// import 'swiper/modules/navigation';
// import 'swiper/modules/pagination';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, A11y } from 'swiper/modules';


/**
 * Initialise le carrousel équipe (Team Slider)
 * Compatible avec Timber + ACF
 */
export function initTeamSlider() {
  const sliders = document.querySelectorAll('.team-slider__inner.swiper');

  if (!sliders.length) return;

  sliders.forEach((sliderEl) => {
    new Swiper(sliderEl, {
      modules: [Navigation, Pagination, A11y],

      // Slides
      loop: true, // infinite scroll
      slidesPerView: 1,
      spaceBetween: 24,
      speed: 600,

      // Responsive
      breakpoints: {
        640: { slidesPerView: 1.2, spaceBetween: 24 },
        1024: { slidesPerView: 2, spaceBetween: 32 },
        1440: { slidesPerView: 4, spaceBetween: 40 },
      },

      // Navigation
      navigation: {
        nextEl: sliderEl.closest('.container').querySelector('.team-slider__nav--next'),
        prevEl: sliderEl.closest('.container').querySelector('.team-slider__nav--prev'),
      },

      // Pagination (points)
      pagination: {
        el: sliderEl.closest('.team-slider').querySelector('.team-slider__pagination'),
        clickable: true,
        dynamicBullets: true,
      },

      // Accessibilité
      a11y: {
        enabled: true,
        prevSlideMessage: 'Slide précédent',
        nextSlideMessage: 'Slide suivant',
        firstSlideMessage: 'Première slide',
        lastSlideMessage: 'Dernière slide',
        paginationBulletMessage: 'Aller à la slide {{index}}',
      },

      // Optionnel : autoplay si tu veux une rotation automatique
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: false,
      // },
    });
  });
}


/**
 * Initialise le carrousel équipe (Team Slider)
 * Compatible avec Timber + ACF
 */
export function initImageSlider() {
  const sliders2 = document.querySelectorAll('.image-slider__inner.swiper');

  if (!sliders2.length) return;

  sliders2.forEach((sliderEl) => {
    new Swiper(sliderEl, {
      modules: [Navigation, Pagination, A11y, Autoplay],

      // Slides
      loop: true, // infinite scroll
      slidesPerView: 1,
      //freeMode: true,
      // loop:true,
      spaceBetween: 24,
      speed: 600,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },

      // Responsive
      breakpoints: {
        640: { slidesPerView: 1, spaceBetween: 24 },
        1024: { slidesPerView: 1, spaceBetween: 32 },
        1440: { slidesPerView: 1, spaceBetween: 40 },
      },

      // Pagination (points)
      pagination: {
        el: sliderEl.closest('.image-slider').querySelector('.image-slider__pagination'),
        clickable: true,
        dynamicBullets: true,
      },

      // Accessibilité
      a11y: {
        enabled: true,
        prevSlideMessage: 'Slide précédent',
        nextSlideMessage: 'Slide suivant',
        firstSlideMessage: 'Première slide',
        lastSlideMessage: 'Dernière slide',
        paginationBulletMessage: 'Aller à la slide {{index}}',
      },

    });
  });
}

